import React, { useContext, useState, useReducer, useEffect } from 'react';
import Breadcrumb from '../../shared/Breadcrumb';
import { AuthContext } from '../../../contexts/AuthContext';
import Util from '../../../Util';
import { Link, useHistory } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import axios from 'axios';
import { apiRoutes } from '../../../AppSettings';
import PatientInfo from './PatientInfo';
import alertify from "alertifyjs";
import Autocomplete from 'react-autocomplete';

const LOAD_ITEMS = "LOAD_ITEMS";
const UPDATE_APPOINMENT = "UPDATE_APPOINMENT";
const UPDATE_PRESCRIPTION_NAME = 'UPDATE_PRESCRIPTION_NAME';
const SET_PRESCRIPTION_ID = 'SET_PRESCRIPTION_ID';
const LOAD_SERVICES = "LOAD_SERVICES";

const itemsInitialValue = {
	prescriptionItemId: 0,
	name: '',
	quantity: '',
	days: '',
	morning: false,
	afternoon: false,
	evening: false,
	night: false
};

const servicesInitialValue = {
	prescriptionServiceId: 0,
	serviceName: '',
	description: ''
};

const initialValue = {
	prescriptionsItem: [itemsInitialValue],
	selectedAppoinmentId: 0,
	name: '',
	prescriptionId: 0,
	prescriptionService: []
}

const reducer = (state, action) => {
	switch(action.type)
	{
		case LOAD_ITEMS:
			return { ...state, prescriptionsItem: action.item };
		case UPDATE_APPOINMENT:
			return { ...state, selectedAppoinmentId: action.selectedAppoinmentId };
		case UPDATE_PRESCRIPTION_NAME:
			return { ...state, name: action.name };
		case SET_PRESCRIPTION_ID:
			return { ...state, prescriptionId: action.prescriptionId};
		case LOAD_SERVICES:
			return { ...state, prescriptionService: action.service };
		default:
			return state;
	} 
}

const AddPrescription = (props) => {
	const prescriptionId = JSON.parse(props.location.state.prescriptionId);
	const doctor = JSON.parse(props.location.state.doctor);
	const patient = JSON.parse(props.location.state.patient);
	const appoinments = JSON.parse(props.location.state.appoinments);

	const [state, dispature] = useReducer(reducer, initialValue);

	const { userState } = useContext(AuthContext);
    const history = useHistory();

	const [inventory, setInventory] = useState([]);
	const [services, setServices] = useState([]);

	const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer '+ userState.token
        }
	};

	useEffect(() => {
		if(appoinments.length == 1)
		{
			dispature({type: UPDATE_APPOINMENT, selectedAppoinmentId: appoinments[0].appoinmentId});
		}

		if(prescriptionId != undefined && prescriptionId != 0 ) {
			handleDelete();
			axios.get(apiRoutes.getPrescriptionById + prescriptionId, options)
			.then((response) => {
			  if(response.status === 200)
			  {
				  const data = response.data;
				  console.log(data);
				  dispature({type: SET_PRESCRIPTION_ID, prescriptionId: data.prescriptionId});
				  dispature({type: LOAD_ITEMS, item: data.prescriptionItem});
				  dispature({type: UPDATE_APPOINMENT, selectedAppoinmentId: data.appoinment.appoinmentId});
				  dispature({type: UPDATE_PRESCRIPTION_NAME, name: data.name});
				  dispature({type: LOAD_SERVICES, service: data.prescriptionService});
			  }
			}, (error) => {
			  console.log(error);
		  });
		}

		axios.get(apiRoutes.GetAllInventory,  options)
			.then((response) => {
			  if(response.status === 200)
			  {
				  const data = response.data;
				  console.log(data);
				  setInventory(data);
			  }
			}, (error) => {
			  console.log(error);
		  });

		axios.get(apiRoutes.GetAllService,  options)
		  .then((response) => {
			if(response.status === 200)
			{
				const data = response.data;
				console.log(data);
				setServices(data);
			}
		  }, (error) => {
			console.log(error);
		});

	}, []);

	
	const loadAppoinment = () => {
		return (
			<select className="form-control select" style={{minWidth: "200px"}} required onChange={(e) => {console.log(e.target.value); dispature({type: UPDATE_APPOINMENT, selectedAppoinmentId: e.target.value})}}>
				<option>--Select Appoinment--</option>
				{
					appoinments.map(item => (
						<option key={item.appoinmentId} value={item.appoinmentId}>{item.appoinmentNumber}</option>
					))
				}
			</select>
		);
	}

	const handleOnChangeService = (value, idToChange, field) => {
		console.log(idToChange);
		state.prescriptionService.forEach(element => {
			if(element.prescriptionServiceId === idToChange)
				updateValues(element, field, value)
		})
		dispature({type: LOAD_SERVICES, service: state.prescriptionService})
	}

	const handleOnChange = (value, idToChange, field) => {
		console.log(idToChange);
		state.prescriptionsItem.forEach(element => {
			if(element.prescriptionItemId === idToChange)
				updateValues(element, field, value)
		})
		dispature({type: LOAD_ITEMS, item: state.prescriptionsItem})
	}

	const updateValues = (item, field, value) =>{
		switch(field)
		{
			case "name":
				item.name = value;
				break;
			case "quantity":
				item.quantity = value;
				break;
			case "days":
				item.days = value;
				break;
			case "morning":
				item.morning = !item.morning;
				break;
			case "afternoon":
				item.afternoon = !item.afternoon;
				break;
			case "evening":
				item.evening = !item.evening;
				break;
			case "night":
				item.night = !item.night;
				break;
			case "serviceName":
				item.serviceName = value; 
				break;
			case "description":
				item.description = value; 
				break;
		}
	}

	const handleDelete = (id) => {
		dispature({type: LOAD_ITEMS, item: state.prescriptionsItem.filter((item) => item.prescriptionItemId !== id)})
	}

	const handleDeleteService = (id) => {
		dispature({type: LOAD_SERVICES, service: state.prescriptionService.filter((item) => item.prescriptionServiceId !== id)})
	}


	const handleAddMoreService = (e) => {
		let minId = 0;
		if(state.prescriptionService.length > 0) {
			minId =	Math.min.apply(Math, state.prescriptionService.map(function(o) { 
				return o.prescriptionServiceId;  
			})); 
		}

		minId = (minId >= 0 ? -1 : minId) - 1;

		let newItem = {
			prescriptionServiceId: minId,
			serviceName: '',
			description: ''
		}

		state.prescriptionService.push(newItem);

		dispature({type: LOAD_SERVICES, service: state.prescriptionService})
	}


	const handleAddMore = (e) => {
		let minId = 0;
		if(state.prescriptionsItem.length > 0) {
			minId =	Math.min.apply(Math, state.prescriptionsItem.map(function(o) { 
				return o.prescriptionItemId;  
			})); 
		}

		minId = (minId >= 0 ? -1 : minId) - 1;

		let newItem = {
			prescriptionItemId: minId,
			name: '',
			quantity: '',
			days: '',
			morning: false,
			afternoon: false,
			evening: false,
			night: false
		}

		state.prescriptionsItem.push(newItem);

		dispature({type: LOAD_ITEMS, item: state.prescriptionsItem})
	}

	const handleSubmit = () => {
		if(state.selectedAppoinmentId == 0)
		{
			console.log('please select appoinment')
			alertify.error("please select appoinment");
			return;
		}

		var route = apiRoutes.addPrescription;
		if(prescriptionId != undefined && prescriptionId != 0)
		{
			route = apiRoutes.updatePrescription;
		}

		axios.post(route, JSON.stringify(state), options)
        .then((response) => {
            if(response.status === 200)
            {
				dispature({type: SET_PRESCRIPTION_ID, prescriptionId: response.data.result });
				alertify.success("Prescription added/updated successfully");

				history.push({
                    pathname:'/PatientProfile',
                    state: {
                        patientId: patient.patientId
                    }
                })
            }
        }, (error) => {
            console.log(error);
        });
	} 

    return (  
        <div>
            <Breadcrumb title={prescriptionId != undefined && prescriptionId != 0 ? "Edit Prescription" : "Add Prescription" } />
            <div className="content">
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
							<PatientInfo patient={patient}></PatientInfo>
						</div>
						<div className="col-md-7 col-lg-8 col-xl-9">
							<div className="card">
								<div className="card-header">
									<h4 className="card-title mb-0">{prescriptionId != undefined && prescriptionId != 0 ? "Edit" : "Add" } Prescription {appoinments.length == 1 && <strong>: {appoinments[0].appoinmentNumber}</strong>}</h4>
								</div>
								<div className="card-body">
									<form onSubmit={e => {e.preventDefault(); handleSubmit();}}>
										<div className="row">
											<div className="col-sm-6">
												<div className="biller-info">
													<h4 className="d-block">Dr. {doctor.firstName} {doctor.lastName}</h4>
													<span className="d-block text-sm text-muted">{doctor.category}</span>
													<span className="d-block text-sm text-muted">{doctor.state}, {doctor.country}</span>
												</div>
											</div>
											<div className="col-sm-6 text-sm-right">
												<div className="billing-info">
													<h4 className="d-block">{Util.getFormatDate({date: (new Date())})}</h4>
													<span className="d-block text-muted">
													</span>
												</div>
											</div>
										</div>
										<div className="row">
											<div className="col-sm-6">
												<div className="form-group">
													<label>Prescription Name: </label>
													<input className="form-control" type="text" required value={state.name} onChange={e => dispature({type: UPDATE_PRESCRIPTION_NAME, name: e.target.value})} />
												</div>
											</div>
											<div className="col-sm-6 text-sm-right">
												<div className="form-group">
													<label>Appoinment: </label>
													{
														console.log(appoinments)
													}
													{
														appoinments.length > 1 ? <select className="select form-control" value={state.selectedAppoinmentId} 
																					onChange={(e) => dispature({type: UPDATE_APPOINMENT, selectedAppoinmentId: e.target.value})}
																					>
																						<option></option>
																						{
																							appoinments.map(item => (
																								<option selected={true} key={item.appoinmentId} value={item.appoinmentId}>{item.appoinmentNumber}</option>
																							))
																						}
																					</select>
																				: 
																				<div> <strong>{appoinments[0] != undefined && appoinments[0].appoinmentNumber}</strong></div>
																					
													}

												</div>
											</div>
										</div>
										<div className="add-more-item text-right">
											<a onClick={e=>handleAddMore(e)} style={{paddingRight: '5px'}}><i className="fas fa-plus-circle"></i> Add Item</a>
											<a onClick={e=>handleAddMoreService(e)}><i className="fas fa-plus-circle"></i> Add Service</a>
										</div>
										<div className="card card-table">
											<div className="card-body">
												<div className="table-responsive">
													<table className="table table-hover table-center">
														<thead>
															<tr>
																<th style={{minWidth: "200px"}}>Name</th>
																<th style={{minWidth: "80px"}}>Quantity</th>
																<th style={{minWidth: "80px"}}>Days</th>
																<th style={{minWidth: "100px"}}>Time</th>
																<th style={{minWidth: "80px"}}></th>
															</tr>
														</thead>
														<tbody>
															{
																state.prescriptionsItem != undefined &&
																state.prescriptionsItem.map(item => (
																	<tr key={item.prescriptionItemId}>
																		<td>
																			<Autocomplete 
																				inputProps={{ id: 'states-autocomplete', className: 'form-control', required: true }}
																				className="form-control"
																				shouldItemRender={(item, value) => item.description.toLowerCase().indexOf(value.toLowerCase()) > -1}
        																		getItemValue={(item) => item.description}
																				items={inventory}
																				renderItem={(item, isHighlighted) =>
																					<div key={item.inventoryId} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '5px 5px 5px 5px' }}>
																						{item.description}
																					</div>
																				}
																				value={item.name}
																				onChange={e => handleOnChange(e.target.value, item.prescriptionItemId, 'name')} 
																				onSelect={(value, state) => handleOnChange(value, item.prescriptionItemId, 'name') }
																				menuStyle={{
																					borderRadius: '3px',
																					boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
																					background: 'rgba(255, 255, 255, 0.9)',
																					padding: '2px 0',
																					fontSize: '90%',
																					position: 'fixed',
																					overflow: 'auto',
																					maxHeight: '50%', // TODO: don't cheat, let it flow to the bottom
																					zIndex: '10'
																				  }}
																			/>
																		</td>
																		<td>
																			<input className="form-control" type="text" required value={item.quantity} onChange={e => handleOnChange(e.target.value, item.prescriptionItemId, 'quantity')}/>
																		</td>
																		<td>
																			<input className="form-control" type="text" required value={item.days} onChange={e => handleOnChange(e.target.value, item.prescriptionItemId, 'days')}/>
																		</td>
																		<td>
																			<div className="form-check form-check-inline">
																				<label className="form-check-label">
																					<input className="form-check-input" type="checkbox" checked={item.morning} onChange={e => handleOnChange(e.target.value, item.prescriptionItemId, 'morning')}/> Morning
																				</label>
																			</div>
																			<div className="form-check form-check-inline">
																				<label className="form-check-label">
																					<input className="form-check-input" type="checkbox" checked={item.afternoon} onChange={e => handleOnChange(e.target.value, item.prescriptionItemId, 'afternoon')}/> Afternoon
																				</label>
																			</div>
																			<div className="form-check form-check-inline">
																				<label className="form-check-label">
																					<input className="form-check-input" type="checkbox" checked={item.evening} onChange={e => handleOnChange(e.target.value, item.prescriptionItemId, 'evening')}/> Evening
																				</label>
																			</div>
																			<div className="form-check form-check-inline">
																				<label className="form-check-label">
																					<input className="form-check-input" type="checkbox" checked={item.night} onChange={e => handleOnChange(e.target.value, item.prescriptionItemId, 'night')}/> Night
																				</label>
																			</div>
																		</td>
																		<td>
																			<a onClick={() => handleDelete(item.prescriptionItemId) } className="btn bg-danger-light trash"><i className="far fa-trash-alt"></i></a>
																		</td>
																	</tr>
																))
															}
														</tbody>
													</table>
												</div>
											</div>
										</div>
										{
												state.prescriptionService != undefined && state.prescriptionService.length > 0  && 
												<div className="card card-table">
													<div className="card-header">
														<h4 className="card-title mb-0">Services</h4>
													</div>
													<div className="card-body">
														<div className="table-responsive">
															<table className="table table-hover table-center">
																<thead>
																	<tr>
																		<th style={{minWidth: "100px"}}>Name</th>
																		<th style={{minWidth: "100px"}}>Description</th>
																		<th style={{minWidth: "80px"}}></th>
																	</tr>
																</thead>
																<tbody>
																	{
																		state.prescriptionService != undefined &&
																		state.prescriptionService.map(item => (
																			<tr key={item.prescriptionServiceId}>
																				<td>
																					<Autocomplete 
																						inputProps={{ id: 'states-autocomplete', className: 'form-control', required: true }}
																						className="form-control"
																						shouldItemRender={(item, value) => item.name.toLowerCase().indexOf(value.toLowerCase()) > -1}
        																				getItemValue={(item) => item.name}
																						items={services}
																						renderItem={(item, isHighlighted) =>
																							<div key={item.serviceId} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '5px 5px 5px 5px' }}>
																								{item.name} 
																							</div>
																						}
																						value={item.serviceName}
																						onChange={e => handleOnChangeService(e.target.value, item.prescriptionServiceId, 'serviceName')} 
																						onSelect={(value, state) => handleOnChangeService(value, item.prescriptionServiceId, 'serviceName') }
																					/>
																				</td>
																				<td>
																					<input className="form-control" type="text" value={item.description} onChange={e => handleOnChangeService(e.target.value, item.prescriptionServiceId, 'description')}/>
																				</td>
																				<td>
																					<a onClick={() => handleDeleteService(item.prescriptionServiceId) } className="btn bg-danger-light trash"><i className="far fa-trash-alt"></i></a>
																				</td>
																			</tr>
																		))
																	}
																</tbody>
															</table>
														</div>
													</div>
												</div>
										}

										<div className="row">
											<div className="col-md-12 text-right">
												<div className="signature-wrap">
													<div className="signature" >
														{doctor.firstName} {doctor.lastName}
													</div>
													<div className="sign-name">
														<p className="mb-0">( Dr. {doctor.firstName} {doctor.lastName} )</p>
														<span className="text-muted">Signature</span>
													</div>
												</div>
											</div>
										</div>
										<div className="row">
											<div className="col-md-12">
												<div className="submit-section">
													<button type="submit" className="btn btn-primary submit-btn">Save</button>
													<Link className="btn btn-secondary submit-btn" 
                                                        to={
                                                            {
                                                                pathname:'/PatientProfile',
                                                                state: {
                                                                    patientId: patient.patientId
                                                                }
                                                            }
                                                    }>Cancel</Link>
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>		
        </div>
    );
}
 
export default AddPrescription;